export const PALETTE_DEFINITIONS = {
    primary: {
        main: "#2C2E6A",
        onMain: "#FFFFFF",
        container: "#F1F1FB",
        onContainer: "#131438",
    },
    secondary: {
        main: "#131438",
        onMain: "#FFFFFF",
        container: "#FBFBFE",
        onContainer: "#03041A",
    },
    accent: {
        main: "#858988",
        onMain: "#FFFFFF",
        container: "#F8FBFA",
        onContainer: "#373D3B",
    },
    surface: {
        main: "#060B0B",
        onMain: "#FFFFFF",
        container: "#F7FAF9",
        onContainer: "#060B0B",
    },
    success: {
        main: "#37B05B",
        onMain: "#FFFFFF",
        container: "#F4FCF7",
        onContainer: "#034733",
    },
    info: {
        main: "#3B82CA",
        onMain: "#FFFFFF",
        container: "#F6F9FE",
        onContainer: "#032061",
    },
    warning: {
        main: "#E6AD39",
        onMain: "#FFFFFF",
        container: "#FEF9F4",
        onContainer: "#9A5500",
    },
    error: {
        main: "#BB4049",
        onMain: "#FFFFFF",
        container: "#FFEAEE",
        onContainer: "#B80817",
    },
    background: {
        main: "#FFFFFF",
        onMain: "#060B0B",
        container: "#F5F7FA",
        onContainer: "#060B0B",
    },
    disabled: {
        main: "#D8D8D8",
        onMain: "#FFFFFF",
        container: "#F7F8FA",
        onContainer: "#A3A3A3",
    },
    celestial: {
        main: "#3E92CC",
        onMain: "#BFDAEE",
        container: "#8EA8C3",
        onContainer: "#13293D",
    },
    cosmic: {
        main: "#4A3AFF",
        onMain: "#C6D2FD",
        container: "#E0C6FD",
        onContainer: "#962DFF",
    },
    venetian: {
        main: "#565676",
        onMain: "#D8DCFF",
        container: "#C38D94",
        onContainer: "#A76571",
    },
    viridian: {
        main: "#2A7F62",
        onMain: "#C1D6D7",
        container: "#588689",
        onContainer: "#143E30",
    },
    chartPositive: {
        main: "#14C283",
        onMain: "#FFFFFF",
        container: "#F0FEF4",
        onContainer: "#00572F",
    },
    chartNegative: {
        main: "#F04C4C",
        onMain: "#FFFFFF",
        container: "#FFEAEE",
        onContainer: "#B80817",
    },
    outline: "#060B0B",
    stroke: {
        50: "#F5F5F5",
        100: "#F2F2F2",
        200: "#E0E0E0",
        300: "#C1C1C1",
    },
};
//# sourceMappingURL=colors.js.map